var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#5A34F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63276 21.3818C8.92329 21.664 9.40474 21.664 9.68696 21.3818L14.9995 16.0693L20.312 21.3818C20.5942 21.664 21.0839 21.6723 21.3662 21.3818C21.6484 21.0913 21.6484 20.6181 21.3662 20.3359L16.0537 15.0151L21.3662 9.70259C21.6484 9.42036 21.6567 8.93891 21.3662 8.65669C21.0756 8.36616 20.5942 8.36616 20.312 8.65669L14.9995 13.9692L9.68696 8.65669C9.40474 8.36616 8.91499 8.35786 8.63276 8.65669C8.35054 8.94722 8.35054 9.42036 8.63276 9.70259L13.9453 15.0151L8.63276 20.3359C8.35054 20.6181 8.34224 21.0996 8.63276 21.3818Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNotify);
export default __webpack_public_path__ + "static/media/close-notify.304d8e1ef883d642e0d5d729e28ac92b.svg";
export { ForwardRef as ReactComponent };